import { EventType, PublicClientApplication } from "@azure/msal-browser";

const cacheOptions = {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: false,
};

let instance = null;

/**
 * Initializes the singleton MSAL PublicClientApplication with the provided configuration.
 *
 * @param {object} config Configuration object containing MSAL authentication settings.
 * @returns {Promise<PublicClientApplication>} instance.
 */
export const init = async (config) => {
    if (instance) return instance;

    const msalOptions = {
        auth: { ...config },
        cache: cacheOptions,
    };

    const msal = new PublicClientApplication(msalOptions);
    await msal.initialize();

    if (!msal.getActiveAccount() && msal.getAllAccounts().length > 0) {
        msal.setActiveAccount(msal.getAllAccounts()[0]);
    }

    msal.addEventCallback((event) => {
        if (
            event.eventType === EventType.LOGIN_SUCCESS &&
            event.payload &&
            "account" in event.payload &&
            event.payload.account
        ) {
            const account = event.payload.account;
            msal.setActiveAccount(account);
        }
    });

    instance = msal;

    return instance;
};
